import type { UnitInfoCrusherVSIInterface } from 'store/units/types';
import { BaseUnitConfig } from 'unitData/BaseUnitConfig';
import VSICrusherCV from './VSI-crusher-CV.png';
import VSIBW from '../../Generic/GenericCrusher/images/VSIBW.png';
import VSICrusherCV2 from './VSI-crusher-CV_2.png';

export class CrusherVSIConfig extends BaseUnitConfig {
  static getDefaultData(): UnitInfoCrusherVSIInterface {
    return {
      modelName: 'CV215',
      ...BaseUnitConfig.getBaseDefaults(),
      motorFrequency: 50,
      motorPower: 55,
      tipSpeed: 52,
      materialShape: materialShapes[0],
      showCustomModel: false,
      display: {
        ...BaseUnitConfig.getDefaultDisplay(),
        displayLoad: true,
        displayRiskLevel: false,
        displayInstalledMotorPower: true,
        displayTipSpeed: true,
        displayMinLiveBin: true,
      },
    };
  }

  static getNumberOfPorts(): number {
    return 2;
  }
}

export const crusherVSIConfig = new CrusherVSIConfig();

export const getCrusherVSIImage = (showCustomModel: boolean) => {
  return showCustomModel ? VSIBW : VSICrusherCV;
};

export const getCrusherVSIImage2 = (showCustomModel: boolean) => {
  return showCustomModel ? VSIBW : VSICrusherCV2;
};

export const materialShapes = [
  { name: 'Cubical', value: 'CUBICAL' },
  { name: 'Angular', value: 'ANGULAR' },
  { name: 'Flaky', value: 'FLAKY' },
];
